import React, {useState, useEffect} from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Aside from '../components/Aside';
import ClipLoader from "react-spinners/ClipLoader";
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables';


const ActiveUsers = () => {
    const [subscriptions, setSubscriptions] = useState([])
	const [loading, setLoading] = useState(false)

    useEffect(() => {
		populate()
	}, [])


    useEffect(() => {
        if (!loading && subscriptions.length > 0) {
            const table = $('#activeusers_config').DataTable({
                order: [[5, 'desc']]
            });
            return () => table.destroy(); // cleanup before re-render
        }
    }, [loading, subscriptions]);


    const populate = () => {
		setLoading(true)
        const endpoint = process.env.REACT_APP_BASE_URL + '/activeusers';
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify({"key_id" : process.env.REACT_APP_BASE_APIKEY})
        })
        .then(response => response.json())
        .then(response => { 
            if(response.error === true){
                setLoading(false)
            }else{
                setSubscriptions(response.data)
                setLoading(false)
            }
           
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }

 	return (

    <>
    
    <div
		id="main-wrapper"
		data-layout="vertical"
		data-navbarbg="skin5"
		data-sidebartype="full"
		data-sidebar-position="absolute"
		data-header-position="absolute"
		data-boxed-layout="full"
    >
		<Header />
		<Aside page="activeusers"/>
  	
		<div className="page-wrapper">
			<div className="page-breadcrumb">
				<div className="row">
					<div className="col-12 d-flex no-block align-items-center">
					<h4 className="page-title">Active Users</h4>
					<div className="ms-auto text-end">
						<nav aria-label="breadcrumb">
						<ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
							<li className="breadcrumb-item active" aria-current="page">
							Active Users
							</li>
						</ol>
						</nav>
					</div>
					</div>
				</div>
			</div>
		
			<div className="container-fluid">
				<div className="row">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Active Users</h5>
                            {
							loading ? 
                                <ClipLoader
                                    color="fff"
                                    loading={loading}
                                    size={10}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                /> : 
                                <div className="table-responsive">
                                    <table
                                    id="activeusers_config"
                                    className="table table-striped table-bordered"
                                    >
                                        <thead style={{ fontWeight:'bold' }}>
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Provider</th>
                                                <th>Newsletter</th>
                                                <th>Creation date</th>
                                                <th>Last access</th>
                                                <th>Process Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                subscriptions.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.name}</td>
                                                        <td>{item.email}</td>
                                                        <td>{item.provider}</td>
                                                        <td>{item.newsletter}</td>
                                                        <td>{item.createdDate}</td>
                                                        <td>{item.access}</td>
                                                        <td>{item.usageProcess}</td>
                                                    </tr>
                                                ))
                                            }                            
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Provider</th>
                                                <th>Newsletter</th>
                                                <th>Creation date</th>
                                                <th>Last access</th>
                                                <th>Process Time</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            }
                        </div>
                    </div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
	</>
  	);
}

export default ActiveUsers;
